// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  deepPurple400,
} from 'material-ui/styles/colors';
import FaceIcon from 'mdi-material-ui/Face';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import NinjaIcon from 'mdi-material-ui/Ninja';

// Internal Dependencies
import NavMenuItem from '../shared/nav-menu-item';
import MainContentContainer from '../shared/main-content-container';
import {
  getUpdateAttendanceUrl,
  getUpdateNinjasUrl,
} from '../route-urls';
import theme from './theme';

// Component Definition
class Dashboard extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      hideAttendanceButton: false,
      names: [],
      showAttendanceDoneMessage: false,
      showAttendanceList: false,
    };
  }

  componentDidMount() {
    window.scroll(0, 0);
  }

  handleClickAddAttendance = () => {
    this.setState({
      hideAttendanceButton: true,
      showAttendanceList: true,
    });
  }

  render() {
    const {
      children,
    } = this.props;

    const navElements = [
      <NavMenuItem
        icon={FaceIcon}
        isLoading={false}
        key="attendance"
        text="Update Attendance"
        url={getUpdateAttendanceUrl()}
      />,
      <NavMenuItem
        icon={NinjaIcon}
        isLoading={false}
        key="ninjas"
        text="Update Ninjas"
        url={getUpdateNinjasUrl()}
      />,
    ];

    return (
      <MuiThemeProvider muiTheme={getMuiTheme(theme)}>
        <MainContentContainer
          backgroundColor={deepPurple400}
          isLoading={false}
          nav={navElements}
          navWidth={272}
          title="Dojo Dashboard"
        >
          {children}
        </MainContentContainer>
      </MuiThemeProvider>
    );
  }
}

export default Dashboard;



/** WEBPACK FOOTER **
 ** ./src/dashboard/index.js
 **/